import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let csrfToken = document.head.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.getAttribute(
    'content'
  );
}

let apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
  axios.defaults.headers.common['Authorization'] =
    'Bearer ' + apiToken.getAttribute('content');
}

global.axios = axios;
export default axios;
